import { Box, Typography } from "@mui/material";
import React, { FC } from "react";

interface IHospitalTimings {
  timings: {
    day: string
    time: string
  }[]
}

const HospitalTimings: FC<IHospitalTimings> = (props) => {
  const isHospitalClosed = (time: string) => {
    if (time.trim().toLowerCase() === "closed") {
      return "text-gray-1";
    }

    return "";
  };

  return (
    <>
      <Box className="flex flex-col gap-2">
        <Typography className="font-xs capitalize text-gray-1 font-bold !mb-1">hospital hours</Typography>
        <Box className="grid grid-cols-2 gap-3">
          {props.timings.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <Typography className={`justify-self-start
                   ${isHospitalClosed(item.time)}`}>{item.day.trim()}</Typography>
                <Typography className={`font-bold justify-self-end
                text-end ${isHospitalClosed(item.time)}`}>{item.time.trim()}</Typography>
              </React.Fragment>
            );
          },
          )}
        </Box>
      </Box>
    </>
  );
};

export default HospitalTimings;
